import React, { useCallback } from "react";
import GlobalNotificationSettings from "src/components/GlobalNotificationSettings";
import { useOrgAnnouncementsForTenant } from "src/hooks/orgConfig";

const GlobalNotifications = () => {
  const { announcements, update, updating } = useOrgAnnouncementsForTenant();

  const onSave = useCallback(
    ({ mapperData, directoryData }) => {
      update({
        mapperNotification: mapperData,
        directoryNotification: directoryData,
      });
    },
    [update]
  );

  return (
    <GlobalNotificationSettings
      notifications={announcements}
      onSave={onSave}
      isSaving={updating}
    />
  );
};

export default GlobalNotifications;
